
@if (showSearchMask) {
    <div class="searchmask">
        <div class="container sm-container">
            <div class="row justify-content-center">

                @if (hotels && hotels.length > 1) {
                    <div class="col-12 col-lg-2 sm-item">
                        <label>{{"sm.Hotel" | translate}}</label>

                        <p-select [options]="hotels" optionLabel="hotelName" optionValue="hotelCode" class="w-100" [formControl]="hotelSelect" [placeholder]="'sm.selectHotel'|translate" [attr.data-testid]="'hotel-select'">
                            <ng-template #dropdownicon>
                                <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                </p-button>
                            </ng-template>
                        </p-select>
                    </div>
                }

                @else if (categories.length > 0) {
                    <div class="col-12 col-lg-2 sm-item sm-category-column">
                        <label>{{"sm.Category" | translate}}</label>
                        <p-select [options]="categories" optionLabel="name" optionValue="value" class="w-100" [formControl]="categorySelect" [attr.data-testid]="'category-select'">
                            <ng-template #dropdownicon>
                                <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                </p-button>
                            </ng-template>
                        </p-select>
                    </div>
                }


                <div class="col-12 col-lg-3 sm-item sm-arrival-departure-column">
                    <label>{{"sm.ArrivalAndDeparture" | translate}}</label>
                    <app-datepicker
                        (onValueChange)="datePickerChanged($event)"
                        [rangeDates]="stay"
                        [showAvailability]="settings.get('datePicker.showAvailability')"
                        [showPrices]="settings.get('datePicker.showPrices')"
                        [hotelCode]="hotelSelect.value"
                        [category]="categorySelect.value"
                    ></app-datepicker>
                </div>
                <div class="col-12 col-lg-4 sm-item sm-rooms-and-occupants-column">
                    <label>{{"sm.RoomsAndOccupants" | translate}}</label>
                    <div class="occupancy w-100" (click)="toggleRoomPicker($event)">
                        {{occupancy.rooms}} @if (occupancy.rooms > 1){{{"sm.rooms" | translate}}}@else{{{"sm.room" | translate}}},
                        {{occupancy.adults}}
                        @if (occupancy.adults > 1){
                            {{"sm.adults" | translate}}}@else{{{"sm.adult" | translate}}}@if(settings.get('searchMask.canBookChildren')){, {{occupancy.children}}

                            @if (occupancy.children == 1){ {{"sm.child" | translate}} } @else{ {{"sm.children" | translate}} }

                        }
                        <p-button icon="pi pi-check" aria-label="Toggle room picker" class="roomPickerArrow" [rounded]="true" [text]="true" (click)="toggleRoomPicker($event)" [attr.data-testid]="'room-picker-button'">

                            @if (roomPickerShown) {
                                <span class="material-symbols-outlined">keyboard_arrow_up</span>
                            }
                            @else {
                                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                            }
                        </p-button>
                    </div>

                    <div class="position-relative">
                        <app-room-picker [rooms]="roomData" (onValueChange)="updateOccupancy($event, true)" (onCloseRoomPicker)="hideRoomPicker()" [class.roomPickerHidden]="!roomPickerShown" [appOutSideClick]="roomPickerShown" (outSideClick)="hideRoomPicker()"></app-room-picker>
                    </div>


                </div>
                <div class="col-12 sm-bookingcode-and-book-button-parentcolumn" [class.col-lg-3]="settings.get('searchMask.bookingCodeType') == 'input'"  [class.col-lg-2]="!settings.get('searchMask.bookingCodeType')">
                    <div class="row h-100">
                        @if (settings.get('searchMask.bookingCodeType')  == 'input') {
                            <div class="col-12 col-lg-6 sm-item sm-bookingcode-column">
                                <label>{{"sm.bookingCode" | translate}}</label>
                                <input class="w-100" pInputText placeholder="{{'sm.insertCode'|translate}}" [formControl]="bookingCode" [attr.data-testid]="'booking-code'">
                            </div>
                        }

                        <div class="col-12 d-flex justify-content-center align-items-end sm-bookingbutton-column" [class.col-lg-6]="settings.get('searchMask.bookingCodeType') == 'input'">
                            <p-button class="sm-book w-100" (click)="search()" [style]="{ gap: '0' }" [attr.data-testid]="'search-rooms'">
                                <span class="material-symbols-outlined">
                                    search
                                </span>
                                {{"sm.Search" | translate}}
                            </p-button>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
}
@else {
    <div class="search-summary">
        <div class="container">
            <div class="search-summary-items">
                <div class="search-summary-header">
                    {{"sm.YourSearch"|translate}} <p-button (click)="openSearchMask()">{{"sm.Change" |translate}}</p-button>
                </div>
                @if ((hotels && hotels.length > 1) && this.hotelSelect.value) {
                    <div> 
                        <label>{{"sm.Hotel"|translate}}</label> 
                        {{getHotelName(this.hotelSelect.value)}}
                    </div>
                }
                <div>
                    <label>{{"sm.Dates"|translate}}</label>
                    <span class="material-symbols-outlined">date_range</span> {{stay[0]|date}} - {{stay[1]|date}}
                </div>
                <div>
                    <label>{{"sm.RoomsAndOccupants" | translate}}</label>
                    <span class="material-symbols-outlined">person</span>{{occupancy.rooms}} @if (occupancy.rooms > 1){{{"sm.rooms" | translate}}}@else{{{"sm.room" | translate}}},
                    {{occupancy.adults}}
                    @if (occupancy.adults > 1){
                        {{"sm.adults" | translate}}}@else{{{"sm.adult" | translate}}}@if(settings.get('searchMask.canBookChildren')){, {{occupancy.children}}

                        @if (occupancy.children == 1){ {{"sm.child" | translate}} } @else{ {{"sm.children" | translate}} }

                    }
                </div>
                @if (bookingCode.value.length > 0) {
                    <div>
                        <label>{{"sm.bookingCode"|translate}}</label>
                        <span class="material-symbols-outlined">sell</span>{{bookingCode.value}}
                    </div>
                }

            </div>
        </div>



    </div>
}


<!-- {{searchParams|json}} -->
